function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../../logger';
import { Observable } from '../../../utils/observables/observable';
import { PlayerState } from '../../player/player-state';
import { TimelineItemType } from './timeline';
import { CoreVideoInternal } from '../../../core-video-internal';
import { isSafariDesktop } from '../../../utils/device-type';
import { JsonUtils } from '../../../utils/json-utils';
import { SmootherType } from '@sky-uk-ott/vpt-abr';
/**
     * Time elapsed since the start of the buffering limit timer
     * This is a sanity check
     */ /**
     * Number of _attempted_ VPF retries
     */ /**
     * Current bandwidth estimate from the bandwidth estimator (if available)
     */ /**
     * The following properties are extracted from the video element
     */ var BUFFER_EXHAUSTED_DETECTION_TOLERANCE_SECS = 2;
export var BufferingLimit = /*#__PURE__*/ function() {
    "use strict";
    function BufferingLimit(config, session, bandwidthEstimator) {
        var _this = this;
        _class_call_check(this, BufferingLimit);
        _define_property(this, "session", void 0);
        _define_property(this, "bandwidthEstimator", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "currentTimeout", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "bufferLimitReachedObservable", void 0);
        _define_property(this, "unregisterPei", void 0);
        _define_property(this, "currentPei", void 0);
        _define_property(this, "currentPosition", void 0);
        _define_property(this, "wasBufferExhaustedOnTimerStart", void 0);
        _define_property(this, "limitTimerStartDate", void 0);
        _define_property(this, "statesToLimit", void 0);
        _define_property(this, "playerState", void 0);
        _define_property(this, "_isCdnSwitching", void 0);
        _define_property(this, "numCdnSwitches", void 0);
        _define_property(this, "videoElement", void 0);
        this.session = session;
        this.bandwidthEstimator = bandwidthEstimator;
        this.logger = sdkLogger.withContext('BufferLimit');
        this.currentTimeout = null;
        this.bufferLimitReachedObservable = new Observable();
        this.currentPei = null;
        this.currentPosition = null;
        this.wasBufferExhaustedOnTimerStart = false;
        this.limitTimerStartDate = null;
        this.statesToLimit = [
            PlayerState.Loading
        ];
        this._isCdnSwitching = false;
        this.numCdnSwitches = 0;
        this.videoElement = null;
        this.config = config;
        if (this.config.enableRebufferingLimit) {
            this.statesToLimit.push(PlayerState.Rebuffering);
        }
        if (this.config.enableSeekingLimit) {
            this.statesToLimit.push(PlayerState.Seeking);
        }
        session.onVideoElementCreated(function(videoElement) {
            _this.videoElement = videoElement;
        });
    }
    _create_class(BufferingLimit, [
        {
            key: "isCdnSwitching",
            get: function get() {
                return this._isCdnSwitching;
            },
            set: function set(value) {
                if (value) {
                    this.numCdnSwitches++;
                }
                this._isCdnSwitching = value;
            }
        },
        {
            key: "playerEngineItemChanged",
            value: function playerEngineItemChanged(param) {
                var _this = this;
                var timelineItem = param.timelineItem, playerEngineItem = param.playerEngineItem;
                if (this.unregisterPei) {
                    this.unregisterPei();
                }
                if (!this.isCdnSwitching) {
                    this.stopTimer();
                }
                this.currentPei = playerEngineItem;
                var timeoutLimitSecs = timelineItem.type === TimelineItemType.MainContent ? this.config.maxMainContentBufferingSecs : this.config.maxAdvertBufferingSecs;
                playerEngineItem.onStateChanged(function(state) {
                    return _this.playerStateChanged(state, timeoutLimitSecs);
                }, this);
                playerEngineItem.onPositionChanged(function(position) {
                    return _this.currentPosition = position;
                }, this);
                this.unregisterPei = function() {
                    playerEngineItem.removeEventListeners(_this);
                    _this.currentPosition = null;
                    _this.currentPei = null;
                };
            }
        },
        {
            key: "onBufferingLimitReached",
            value: function onBufferingLimitReached(callback, owner) {
                var _this = this;
                this.bufferLimitReachedObservable.registerObserver(function() {
                    var e = _this.detectErrorReason();
                    e.stats = _this.buildStats();
                    callback(e);
                }, owner);
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(owner) {
                this.bufferLimitReachedObservable.unregisterObservers(owner);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.stopTimer();
                if (this.unregisterPei) {
                    this.unregisterPei();
                }
                this.currentPei = null;
                this.videoElement = null;
            }
        },
        {
            key: "buildStats",
            value: function buildStats() {
                var _this_videoElement, _this_videoElement1, _this_videoElement2, _this_videoElement3, _this_videoElement4, _this_videoElement5, _this_videoElement6, _this_videoElement7;
                if (this.playerState === undefined) {
                    return;
                }
                var stats = {
                    timeElapsedSecs: this.limitTimerStartDate ? (Date.now() - this.limitTimerStartDate) / 1000 : 0,
                    playerState: this.playerState,
                    internalSessionState: this.session.getCurrentState(),
                    numCdnSwitches: this.numCdnSwitches,
                    numVpfRetries: this.session.getNumVpfRetryAttempts(),
                    videoDuration: (_this_videoElement = this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.duration,
                    videoCurrentTime: (_this_videoElement1 = this.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.currentTime,
                    videoMuted: (_this_videoElement2 = this.videoElement) === null || _this_videoElement2 === void 0 ? void 0 : _this_videoElement2.muted,
                    videoAutoplay: (_this_videoElement3 = this.videoElement) === null || _this_videoElement3 === void 0 ? void 0 : _this_videoElement3.autoplay,
                    videoPlaybackRate: (_this_videoElement4 = this.videoElement) === null || _this_videoElement4 === void 0 ? void 0 : _this_videoElement4.playbackRate,
                    videoPaused: (_this_videoElement5 = this.videoElement) === null || _this_videoElement5 === void 0 ? void 0 : _this_videoElement5.paused,
                    videoReadyState: (_this_videoElement6 = this.videoElement) === null || _this_videoElement6 === void 0 ? void 0 : _this_videoElement6.readyState,
                    videoNetworkState: (_this_videoElement7 = this.videoElement) === null || _this_videoElement7 === void 0 ? void 0 : _this_videoElement7.networkState
                };
                if (this.bandwidthEstimator) {
                    if ('getBandwidthEstimate' in this.bandwidthEstimator) {
                        stats.bandwidthEstimate = this.bandwidthEstimator.getBandwidthEstimate({
                            forceUpdate: true
                        });
                    } else {
                        var smoother = this.bandwidthEstimator.getSmoother({
                            type: SmootherType.HARMONIC_MEAN
                        });
                        stats.bandwidthEstimate = smoother.getValue();
                        smoother.unregister();
                    }
                }
                return JsonUtils.objToKeyValuePair(stats);
            }
        },
        {
            key: "detectErrorReason",
            value: function detectErrorReason() {
                var _this_currentPei, _this_currentPei1;
                var isBackground = CoreVideoInternal.lifecycle.isAppBackgrounded();
                var backgroundPrefix = isBackground ? 'BACKGROUND.' : '';
                var isLoading = ((_this_currentPei = this.currentPei) === null || _this_currentPei === void 0 ? void 0 : _this_currentPei.state) === PlayerState.Loading;
                var isSeeking = ((_this_currentPei1 = this.currentPei) === null || _this_currentPei1 === void 0 ? void 0 : _this_currentPei1.state) === PlayerState.Seeking;
                var isSafari = isSafariDesktop(CoreVideoInternal.deviceInfo, CoreVideoInternal.deviceType);
                var limitType = isLoading ? 'LOADING_LIMIT' : 'BUFFERING_LIMIT';
                var context = "".concat(backgroundPrefix).concat(limitType);
                var gapsCheckInfo = this.checkForGaps();
                if (gapsCheckInfo) {
                    if (gapsCheckInfo.audio && gapsCheckInfo.video) {
                        return {
                            code: "".concat(context, ".NEAR_AUDIO_AND_VIDEO_GAP"),
                            message: 'Reached buffering limit near buffer audio and video gap',
                            shouldFailSilently: false
                        };
                    }
                    if (gapsCheckInfo.video) {
                        return {
                            code: "".concat(context, ".NEAR_VIDEO_GAP"),
                            message: 'Reached buffering limit near buffer video gap',
                            shouldFailSilently: false
                        };
                    }
                    if (gapsCheckInfo.audio) {
                        return {
                            code: "".concat(context, ".NEAR_AUDIO_GAP"),
                            message: 'Reached buffering limit near buffer audio gap',
                            shouldFailSilently: false
                        };
                    }
                    if (gapsCheckInfo.total) {
                        return {
                            code: "".concat(context, ".NEAR_GAP"),
                            message: 'Reached buffering limit near buffer gap',
                            shouldFailSilently: false
                        };
                    }
                }
                if (this.wasBufferExhaustedOnTimerStart) {
                    return {
                        code: "".concat(context, ".BUFFER_EXHAUSTED"),
                        message: 'Buffer exhausted for too long',
                        shouldFailSilently: false
                    };
                }
                if (isSafari && isSeeking) {
                    return {
                        code: "".concat(context, ".UNKNOWN_REASON"),
                        message: 'Buffering too long for unknown reason',
                        shouldFailSilently: isBackground
                    };
                }
                return {
                    code: "".concat(context, ".UNKNOWN_REASON"),
                    message: 'Buffering too long for unknown reason',
                    shouldFailSilently: isLoading && isBackground
                };
            }
        },
        {
            key: "checkForGaps",
            value: function checkForGaps() {
                var _this_currentPei;
                var bufferedRanges = (_this_currentPei = this.currentPei) === null || _this_currentPei === void 0 ? void 0 : _this_currentPei.getBufferedInfo();
                if (!bufferedRanges) {
                    return null;
                }
                return {
                    total: this.bufferedRangesContainGap(bufferedRanges.total),
                    audio: this.bufferedRangesContainGap(bufferedRanges.audio),
                    video: this.bufferedRangesContainGap(bufferedRanges.video)
                };
            }
        },
        {
            key: "bufferedRangesContainGap",
            value: function bufferedRangesContainGap(bufferedRanges) {
                return Boolean(bufferedRanges) && bufferedRanges.length > 1;
            }
        },
        {
            key: "isBufferExhausted",
            value: function isBufferExhausted() {
                var _this_currentPei;
                var bufferedInfo = (_this_currentPei = this.currentPei) === null || _this_currentPei === void 0 ? void 0 : _this_currentPei.getBufferedInfo();
                if (!bufferedInfo) {
                    return false;
                }
                var bufferedRanges = bufferedInfo.total;
                if (!bufferedRanges || this.currentPosition === null || bufferedRanges.length === 0) {
                    return false;
                }
                var bufferEnd = bufferedRanges[bufferedRanges.length - 1];
                return bufferEnd.end - BUFFER_EXHAUSTED_DETECTION_TOLERANCE_SECS <= this.currentPosition && this.currentPosition <= bufferEnd.end;
            }
        },
        {
            key: "playerStateChanged",
            value: function playerStateChanged(state, timeoutLimitSecs) {
                var _this = this;
                this.playerState = state;
                if (this.statesToLimit.includes(state)) {
                    this.startTimer(state, timeoutLimitSecs);
                } else if (!this.isCdnSwitching) {
                    setTimeout(function() {
                        return _this.stopTimer();
                    });
                }
            }
        },
        {
            key: "startTimer",
            value: function startTimer(state, timeoutLimitSecs) {
                var _this = this;
                this.logger.info('Timer starting');
                if (!this.currentTimeout) {
                    this.wasBufferExhaustedOnTimerStart = this.isBufferExhausted();
                    this.limitTimerStartDate = Date.now();
                    this.currentTimeout = setTimeout(function() {
                        _this.bufferLimitReachedObservable.notifyObservers();
                    }, timeoutLimitSecs * 1000);
                }
            }
        },
        {
            key: "stopTimer",
            value: function stopTimer() {
                this.logger.info("Timer stopped");
                this.wasBufferExhaustedOnTimerStart = false;
                this.limitTimerStartDate = null;
                if (this.currentTimeout) {
                    clearTimeout(this.currentTimeout);
                    this.currentTimeout = null;
                }
            }
        }
    ]);
    return BufferingLimit;
}();

//# sourceMappingURL=buffering-limit.js.map